import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-hair-growth',
  templateUrl: './hair-growth.component.html',
  imports: [UpsellCardComponent],
})
export class HairGrowthComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.Minoxidil;
}
